import {
    Component, Input
} from '@angular/core';

import { BaseComponent } from '@tytapp/common';
import { ApiPoll, PollsApi } from '@tytapp/api';
import { FollowButton, HomeCard, HomeCardComponentType, HomeCardIcon, HomeCardLink } from '@tytapp/app/pages/home-page/home-cards.service';

export interface PollHomeCard extends HomeCard {
    type: 'poll';
    poll: ApiPoll;
}

export interface PetitionHomeCard extends HomeCard {
    type: 'petition';
    petition: ApiPoll;
}

@Component({
    selector: 'tyt-featured-card-poll',
    templateUrl: './featured-card-poll.component.html',
    styleUrls: ['./featured-card-poll.component.scss']
})
export class FeaturedCardPollComponent extends BaseComponent implements HomeCardComponentType {
    card: PollHomeCard | PetitionHomeCard;
    fullBleed = true;
    expectedType: 'ChooseOnePoll' | 'Petition' = 'ChooseOnePoll';

    get poll() {
        if (this.card.type === 'poll')
            return this.card.poll;
        else if (this.card.type === 'petition')
            return this.card.petition;
    }

    get title() {
        if (this.card?.type === 'petition')
            return `Featured Petition`;

        return `Featured Poll`;
    }

    get more(): HomeCardLink {
        if (this.card?.type === 'petition')
            return { url: '/campaigns', label: 'View All Petitions' };
        else if (this.card?.type === 'poll')
            return { url: '/polls', label: 'View All Polls' };
    }

    icon?: HomeCardIcon;
    get hidden() { return !this.poll && !this.card.placeholder }
}
